var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-filter',{attrs:{"filter-list":_vm.table_filter},on:{"search":_vm.search}}),_c('app-table',{ref:"app-table",attrs:{"table-key":_vm.table_key,"tablep":_vm.table_params,"page-size":15,"get-data":_vm.getTemplateList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }